// Home.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Contact from './Contact';
import './home.css';
import './font.css'
import NewNavbar from './Navbar';
import Employees from './Employees'; // Import the Employees component
import Service from './Service'; // Import the Employees component
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // 引入Swiper的样式
import { EffectFade, Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Col, Container, Row, Image } from 'react-bootstrap';
import { FaMale, FaFemale, FaChild, FaUserTie } from 'react-icons/fa';
// const slides = [

//   { src: '/images/hair1.jpg', alt: 'Slide 1' },
//   { src: '/images/hair2.jpg', alt: 'Slide 2' },
//   { src: '/images/hair3.jpg', alt: 'Slide 3' },
//   { src: '/images/hair4.jpg', alt: 'Slide 4' },
//   { src: '/images/hair5.jpg', alt: 'Slide 5' },
//   { src: '/images/hair6.jpg', alt: 'Slide 6' },
//   { src: '/images/hair7.jpg', alt: 'Slide 7' },
//   { src: '/images/hair8.jpg', alt: 'Slide 8' },
//   { src: '/images/hair9.jpg', alt: 'Slide 9' },
//   { src: '/images/image1.jpg', alt: 'Slide 10' },
//   { src: '/images/image2.jpg', alt: 'Slide 11' },
//   { src: '/images/image3.jpg', alt: 'Slide 12' },
//   { src: '/images/image4.jpg', alt: 'Slide 13' },
//   { src: '/images/image5.jpg', alt: 'Slide 14' },
// ];


const GSheetReader = require('g-sheets-api');

function Home() {


  const [activeSlide, setActiveSlide] = useState(0);
  const [homeTitleText, setHomeTitleText] = useState(''); // 状态用于存储从Google Sheets获取的标题
  const [h1, setH1] = useState('');
  const [p1, setP1] = useState('');
  const [side_background, setSB] = useState('');

  const [showModal, setShowModal] = useState(true);
  // const HomeH1 = configData.HomeH1



  // New services section data
  const services = [
    {
      title: 'Haircuts for Men',
      description: 'At Asian Beauty Salon, we specialize in men’s haircuts, offering styles like fades, crew cuts, and classic trims tailored to each client’s preference. Our experienced barbers ensure you get the look you want at a price that suits your budget, leaving you confident and refreshed.',
      image: '/images/haircut_men.jpg',
      icon: <FaMale className="service-icon" />,
    },
    {
      title: 'Haircuts for Women',
      description: 'Asian Beauty Salon provides a variety of haircut styles for women, from chic bobs and layered lobs to sleek, long layers and modern blunt cuts. No matter your style, our stylists are skilled at delivering a look that reflects your personality and enhances your natural beauty.',
      image: '/images/haircut_women.jpg',
      icon: <FaFemale className="service-icon" />,
    },
    {
      title: 'Haircuts for Kids',
      description: 'Our team at Asian Beauty Salon enjoys creating a fun, welcoming environment for our youngest clients. We offer children’s haircuts designed to keep them smiling throughout the experience. If it’s your child’s first haircut, let us know, and we’ll make it extra special!',
      image: '/images/haircut_kids.jpg',
      icon: <FaChild className="service-icon" />,
    },
    {
      title: 'Haircuts for Seniors',
      description: 'Asian Beauty Salon takes pride in catering to all hair types and textures, including those of our senior clients. Whether your hair is thick, thin, colored, or natural, our stylists understand the nuances of senior hair care and are committed to providing a comfortable, stylish experience.',
      image: '/images/haircut_seniors.jpg',
      icon: <FaUserTie className="service-icon" />,
    },
  ];


  // const imageUrl = '/images/image1.jpg';
  // const backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/image1.jpg') no-repeat 0% 20%`;
  const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
  //   }, 5000); // 每3秒切换一次

  //   return () => clearInterval(interval); // 清理定时器
  // }, []);

  // const backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${slides[currentIndex].src}') no-repeat 0% 20%`;


  const [HomeH1, setHomeH1] = useState("");
  const [HomeP1, setHomeP1] = useState("");
  const [HomeH2, setHomeH2] = useState("");
  const [HomeP2, setHomeP2] = useState("");
  const [HomeH3, setHomeH3] = useState("");
  const [HomeH4, setHomeH4] = useState("");
  const [HomeP3, setHomeP3] = useState("");
  const [NavigationLink, setNavigationLink] = useState("");
  const [GoogleMapAPI, setGoogleMapAPI] = useState("");
  const [HomeImage1, setHomeImage1] = useState("");
  const [slides, setSlides] = useState([]);
  const [Discount, setDiscount] = useState('');


  useEffect(() => {

    fetch('/config.json')
      .then(response => response.json())
      .then(data => {
        // console.log(data.HomeH1);
        setHomeH1(data.HomeH1);
        setHomeP1(data.HomeP1);
        setHomeH2(data.HomeH2);
        setHomeP2(data.HomeP2);
        setHomeH3(data.HomeH3);
        setHomeH4(data.HomeH4);
        setHomeP3(data.HomeP3);
        setNavigationLink(data.NavigationLink);
        setGoogleMapAPI(data.GoogleMapAPI);
        setHomeImage1(data.HomeImage1);
        setDiscount(data.Discount);
        const slideData = [];
        for (const [key, value] of Object.entries(data)) {
          if (key.startsWith("HomeSwiper")) {
            console.log(key, value)
            slideData.push({ src: value, alt: key });
          }
        }
        setSlides(slideData);
        // console.log(slides);
      })
      .catch(error => console.error('Error loading config:', error));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Function to open the modal popup
  const openModal = () => {
    setShowModal(true);
  };

  // Function to close the modal popup
  const closeModal = () => {
    setShowModal(false);
  };

  // read google sheet data

  function getValueByKey(results, key) {
    const item = results.find(entry => entry.key === key);
    return item ? item.Value : ""; // 如果找到，返回 Value，否则返回 null
  }

  const handleNavigation = () => {
    // window.location.href = 'https://maps.google.com/maps/dir//Asian+Beauty+Salon,+Inc.+611+E+Grand+River+Ave+%23200+East+Lansing,+MI+48823/@42.7332412,-84.4758824,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x8822e920ca8cbe01:0x7be6b1912c338548';
    window.location.href = NavigationLink;
  };

  const handleAppointment = () => {
    // Route to the booking page
    window.location.href = 'https://asianbeautysalon.setmore.com/weixin';

  };

  useEffect(() => {
    openModal();
    // const options = {
    //   apiKey: 'AIzaSyAKMN26phfEvXQKd9o-za_hpzHlptGzBFA',
    //   sheetId: '1cG4Tlm1YgdLCZKuivkSyy8pOcx-YzEZ5Trxh8GYvhDY',
    //   sheetName: "工作表1",
    // };

    // GSheetReader(options, results => {
    //   setHomeTitleText(getValueByKey(results, "HomeTitleText"));
    //   setH1(getValueByKey(results, "h1"));
    //   setP1(getValueByKey(results, "p1"));
    //   setSB(getValueByKey(results, "side_bg"));
    //   setDC(getValueByKey(results, "discount"));
    // });

    // 创建并插入google字体使用的 link 标签
    const linkPreconnect1 = document.createElement('link');
    linkPreconnect1.rel = 'preconnect';
    linkPreconnect1.href = 'https://fonts.googleapis.com';

    const linkPreconnect2 = document.createElement('link');
    linkPreconnect2.rel = 'preconnect';
    linkPreconnect2.href = 'https://fonts.gstatic.com';
    linkPreconnect2.crossOrigin = 'anonymous';

    const linkStylesheet = document.createElement('link');
    linkStylesheet.href = 'https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap';
    linkStylesheet.rel = 'stylesheet';

    // 将这些链接添加到 head 中
    document.head.appendChild(linkPreconnect1);
    document.head.appendChild(linkPreconnect2);
    document.head.appendChild(linkStylesheet);

    // 清理函数，移除插入的标签
    return () => {
      document.head.removeChild(linkPreconnect1);
      document.head.removeChild(linkPreconnect2);
      document.head.removeChild(linkStylesheet);
    };
  }, []);

  return (
    <div className=' merriweather-light'>
      {showModal && (
        <div className="newmodal">
          <div className="modal-content">
            <span className="close-button" onClick={closeModal}>&times;</span>
            <img src={Discount} alt="Discount Information" style={{ width: '100%' }} />
          </div>
        </div>
      )}
      <NewNavbar />
      {/* <button onClick={openModal} className="popup-button">Show Discount Info</button> */}

      <div className='swiper-container'>
        <Swiper
          spaceBetween={0}
          effect={'fade'}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          // navigation={true}
          modules={[EffectFade, Autoplay, Pagination]}
          className="mySwiper"
          style={{ height: '100vh' }} // 设置轮播图高度
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  height: '100%',
                  background: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url('${slide.src}') no-repeat center center/cover`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white', // 文字颜色
                }}
              >

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      
      <div className='HomeTitleText merriweather-light'>
        <h1>{HomeH1}</h1>
        <p>{HomeP1}</p>
      </div>

      <div class="box">
        <div class="imagebox">
          <img src={HomeImage1} alt="This is img"></img>
        </div>
        <div class="textbox merriweather-light" >
          <h1>{HomeH2}</h1>
          <p>{HomeP2}</p>
        </div>
      </div>


      {/* Services Section */}
      <Container className="services-section my-5">
        {services.map((service, index) => (
          <Row className="service-card align-items-center" key={index}>
            <Col md={3}>
              <Image src={service.image} alt={service.title} fluid />
            </Col>
            <Col md={9} className="service-content">
              <div className="service-title">
                {service.icon} {service.title}
              </div>
              <p className="service-description">{service.description}</p>
            </Col>
          </Row>
        ))}
      </Container>


      <div class="box reverse">
        <div class="imagebox">
          <iframe
            src={GoogleMapAPI}
            width="100%"
            height="450"
            allowFullScreen=""
            loading="lazy"
            title="Barbershop Location"
          ></iframe>
        </div>
        <div class="textbox merriweather-light" >
          <h1>{HomeH3}<br></br></h1>
          <h2>{HomeH4}</h2>
          <p>{HomeP3}</p>
          <div class="buttonbox">
            <button onClick={handleNavigation}>navigation</button>
            <button onClick={handleAppointment}>appointment</button>
          </div>

        </div>
      </div>
      <Routes>
        <Route path='/contact' element={<Contact />} />
        <Route path='/employees' element={<Employees />} />
        <Route path='/service' element={<Service />} />
      </Routes>

    </div>

  );
}

export default Home;